import { toast } from "../components/Toast/toast";

// One CSV writer for every "Export to Excel" button in the portal.
//
// CSV rather than a real .xlsx: Excel opens it natively and it needs no
// spreadsheet library in the bundle. The BOM matters - without it Excel reads
// the file as the system codepage and mangles every non-ASCII name, which in a
// translation portal is most of them.
const BOM = "﻿";

const escapeCell = (value) => {
  if (value === null || value === undefined) return "";
  const text = String(value);
  // A leading =, +, - or @ is treated as a formula by Excel; prefix it so the
  // cell is read as text.
  const safe = /^[=+\-@]/.test(text) ? `'${text}` : text;
  return `"${safe.replace(/"/g, '""')}"`;
};

const timestamp = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/**
 * columns: [{ header, value: (row, index) => cell }]
 * rows:    the records currently backing the table
 *
 * Returns the number of rows written, so a caller can report an empty export.
 */
export const exportRowsToCsv = (baseName, columns, rows = []) => {
  const lines = [
    columns.map((c) => escapeCell(c.header)).join(","),
    ...rows.map((row, index) =>
      columns.map((c) => escapeCell(c.value(row, index))).join(",")
    ),
  ];

  const blob = new Blob([BOM + lines.join("\r\n")], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${baseName}-${timestamp()}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  return rows.length;
};

// What the buttons call: exports the rows, or says why it did not.
export const exportTable = (baseName, columns, rows = []) => {
  if (!rows.length) {
    toast.info("There is nothing to export.");
    return 0;
  }
  try {
    const count = exportRowsToCsv(baseName, columns, rows);
    toast.success(`Exported ${count} row${count === 1 ? "" : "s"}.`);
    return count;
  } catch (err) {
    console.error("Export failed", err);
    toast.error("Could not export the table.");
    return 0;
  }
};
